import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

interface Props {
  children: React.ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  priceLine: {
    ...theme.fonts.caption,
  },
  table: {
    width: '100%',
    borderSpacing: `0 ${theme.marginBase}px`,
    borderCollapse: 'separate',
  },
  price: {
    textAlign: 'right',
  },
}));

export const ProductLinesContainer = ({ children }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return <table className={classes.table}>{children}</table>;
};
